<template lang="pug">
#app
  .page-container(v-if="!print && loaded")
    //tab-blur-watcher
    md-progress-bar#progress-bar.md-accent(md-mode="indeterminate" v-show="progress")
    md-app(v-bind:class="{ 'no-padding': !showRight && sidebar }")
      md-app-toolbar#main-toolbar.md-dense.md-primary.main-toolbar(v-if="logged" md-elevation="1")
        toolbar(:sidebar="sidebar")
      md-app-content#main( v-bind:class="{'left-offset': sidebar}")
        .sidebar(v-if="logged" v-bind:class="{'active': sidebar}")
          main-menu
        #main-layout.md-layout.md-alignment-top-center
          .md-layout-item.md-content.center(md-theme="white"): router-view
          transition(name="slideright" mode="out-in")
            .md-layout-item.md-content.right(md-theme="white" v-show="showRight" v-bind:style="rightPanelStyle")
              router-view(name="right")
          dynamic-right-panel
          //.md-layout-item.md-content.right(v-bind:class="rightClasses" md-theme="white" v-show="showRight"): router-view(name="right")
  #print-view(v-if="print && loaded")
    router-view
  Snackbar
  ZModalAlert
</template>
<script>
    import toolbar from './components/Toolbar';
    import MainMenu from './components/MainMenu';
    import Snackbar from './components/Snackbar';
    import TabBlurWatcher from './components/TabBlurWatcher';
    import DynamicRightPanel from './components/DynamicRightPanel';
    import ZModalAlert from './components/ZModalAlert'
    export default {
      name: 'app',
      components: {toolbar, MainMenu, Snackbar, TabBlurWatcher, DynamicRightPanel, ZModalAlert},
      data() {
        return {
          sidebar: !!parseInt(this.$cookie.get('sidebar'))
        }
      },
      created() {
        this.$root.$on('toggle-sidebar', (value) => this.toggleSidebar(value));
      },
      computed: {
        loaded() {
          return this.$root.loaded;
        },
        user() {
          return this.$store.state.users.current;
        },
        logged() {
          return this.user && this.user.id;
        },
        snackbar() {
          return this.$store.state.snackbar;
        },
        progress() {
          return this.$store.state.progress;
        },
        showRight() {
          return this.$store.state.rightPanel
        },
        rightPanelStyle() {
          return this.$store.state.rightPanelStyle
        },
        centerClasses() {
          return {
            'md-size-100': !this.showRight && this.$store.state.centralFlexSize == 'big',
            'md-size-65': this.showRight && this.$store.state.centralFlexSize == 'big',
            'md-size-50': this.$store.state.centralFlexSize == 'medium',
            'md-size-20': this.$store.state.centralFlexSize == 'small'
          }
        },
        rightClasses() {
          return {
            'md-size-35': this.$store.state.centralFlexSize == 'big',
            'md-size-50': this.$store.state.centralFlexSize == 'medium',
            'md-size-80': this.$store.state.centralFlexSize == 'small',
          }
        },
        menus() {
          return this.$root.menus
        },
        toolbars() {
          return this.$root.toolbars
        },
        print() {
          return this.$store.state.print
        }
      },
      methods: {
        //открыть/закрыть боковую панель
        toggleSidebar(value) {
          if (value !== undefined) this.sidebar = !!value;
          else this.sidebar = !this.sidebar;

          //сохраняем состояние
          this.$cookie.set('sidebar', Number(this.sidebar), { expires: '1M' });
        },
        logout() {
          this.$store.dispatch('users/logout').then(() => { this.$router.push({name: 'Logout'}); });
        }
      },
      watch: {
        //следим за изменением страницы, чтобы каждый раз сбрасывать состояние открытой задачи
        '$route.path'() {
          this.$store.commit('closeRightPanel');
          this.$store.commit('setRightPanelWidth');
          this.$store.commit('setBigSizePanel');
        }
      }
    }
</script>
<style lang="sass">
  @import url("//fonts.googleapis.com/css?family=Roboto:300,400,500,700,400italic")
  @import url("//fonts.googleapis.com/icon?family=Material+Icons")
  @import "~vue-material/dist/theme/engine"
  @include md-register-theme("default", ( primary: md-get-palette-color(blue, 500), accent: md-get-palette-color(red, A200), background: md-get-palette-color(grey, 100) ))
  @include md-register-theme("white", ( primary: md-get-palette-color(blue, 500), accent: md-get-palette-color(red, A200), background: md-get-palette-color(white, 50) ))
  @include md-register-theme("green", ( primary: md-get-palette-color(teal, 500), accent: md-get-palette-color(red, A200), background: md-get-palette-color(white, 50) ))
  //костыль для node-sass версии больше 4.7.2
  \:root
    --md-theme-default-primary: #2196f3
    --md-theme-default-accent:  #FF5252
    --md-theme-default-background: #FAFAFA
    --md-theme-white-primary: #2196f3
    --md-theme-white-accent:  #FF5252
    --md-theme-white-background: #FFFFFF
    --md-theme-green-primary: #009688
    --md-theme-green-accent:  #FF5252
    --md-theme-green-background: #FFFFFF

  @import "~vue-material/dist/theme/all"
  @import "assets/sass/variables.sass"
  @import "assets/sass/grid.sass"
  @import "assets/sass/app.sass"
  @import "assets/sass/loader.sass"
</style>



// WEBPACK FOOTER //
// App.vue?304e6080